import Vue from "vue";
import { Toast, Popup, Field, Button, Loading, Overlay } from "vant";

Vue.use(Toast);
Vue.use(Popup);
Vue.use(Field);
Vue.use(Button);
Vue.use(Loading);
Vue.use(Overlay);
